import { Log } from '../log';
import { Service } from '../services/Service';
import { Platform } from './Platform';
import { SupportedCompanies, SupportedPlatforms, SupportedTags } from './Tags';
import { PlatformTag } from './types';

interface ConfigureOptions {
    platform?: PlatformTag | Platform;

    fetchPlatform: () => Platform | PlatformTag;
}

const logger = Log.channel('PlatformService');

export class PlatformService extends Service<PlatformService>() {
    public static PLATFORMS = SupportedPlatforms;
    public static COMPANIES = SupportedCompanies;
    public static TAGS = SupportedTags;

    private currentPlatform: Platform;

    public setPlatform(platform: PlatformTag | Platform) {
        this.currentPlatform = Platform.from(platform);
    }

    public getPlatform(): Platform {
        return this.currentPlatform || Platform.from(SupportedTags.APPAREL_ORDER);
    }

    /**
     * Get the tag string of the current platform
     */
    public getTag(): PlatformTag {
        return this.getPlatform().toString();
    }

    /**
     * Configure service with all things we need.
     * @param options
     */
    public static configure(options: Partial<ConfigureOptions> = {}) {
        logger.debug('Configure');
        const service = this.instance;

        if (options.platform) {
            service.setPlatform(options.platform);
        } else if (options.fetchPlatform) {
            service.setPlatform(options.fetchPlatform());
        } else if (typeof document !== 'undefined') {
            service.setPlatform(service.getDocumentPlatform());
        }
    }

    public getDocumentPlatform() {
        const meta = document.querySelector<HTMLMetaElement>('meta[name=platform]');
        return Platform.from(meta?.content ?? SupportedTags.APPAREL_ORDER);
    }

    public match(platform: PlatformTag | SupportedPlatforms | SupportedCompanies | SupportedTags) {
        return this.getPlatform().isLike(platform);
    }

    public static match(platform: PlatformTag | SupportedPlatforms | SupportedCompanies | SupportedTags) {
        return this.instance.match(platform);
    }
}
